export default __webpack_public_path__ + "static/Aeonik-AirItalic-6cdd44c60938cf4fc0341943f137d4f4.otf";